module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumbBlurSmall/LadiesinLavender-448x252.16c948d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumbBlurSmall/LadiesinLavender-448x252.jpg
// module id = dMPf
// module chunks = 0